import React, { FC, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IObject } from 'types';
import { FiasSearchProps } from '../../../../../../../../types';
import { Option } from '../option';
import { Ul, Li } from './options-list.styled';

type OptionsListProps = {
  items: IObject[];
} & Partial<Pick<ItemProps, 'level' | 'parent'>> &
  Pick<FiasSearchProps, 'flat' | 'selectOnlyHouses' | 'disabledHouses'>;

export const OptionsList: FC<OptionsListProps> = observer(
  ({
    items,
    level = 0,
    flat,
    parent = '',
    selectOnlyHouses,
    disabledHouses,
  }) => {
    return (
      <Ul>
        {items.map((item, index: number) => (
          <Item
            selectOnlyHouses={selectOnlyHouses}
            key={index}
            item={item}
            level={level + 1}
            flat={flat}
            parent={parent}
            disabledHouses={disabledHouses}
          />
        ))}
      </Ul>
    );
  }
);

type ItemProps = {
  item: IObject;
  level: number;
  parent: string;
} & Pick<FiasSearchProps, 'flat' | 'selectOnlyHouses' | 'disabledHouses'>;

const Item: FC<ItemProps> = observer(
  ({ item, level, flat, parent, selectOnlyHouses, disabledHouses }) => {
    const [show, setShow] = useState<boolean>(false);

    const handleChangeShowOptions = () => {
      setShow((show) => !show);
    };

    return (
      <Li>
        <Option
          item={item}
          show={show}
          setShow={handleChangeShowOptions}
          level={level}
          flat={flat}
          parent={parent}
          selectOnlyHouses={selectOnlyHouses}
          disabledHouses={disabledHouses}
        />
        {/*Раскрывающийся список*/}
        {show &&
          ((flat && item.houses?.length && !item.title) ||
            item.inheritors?.length) && (
            <OptionsList
              items={item.inheritors || item.houses}
              level={level + 1}
              flat={flat}
              parent={item.AOGUID}
              selectOnlyHouses={selectOnlyHouses}
              disabledHouses={disabledHouses}
            />
          )}
      </Li>
    );
  }
);
